import { render } from "./ContributionDialog.vue?vue&type=template&id=412a360b"
import script from "./ContributionDialog.vue?vue&type=script&lang=js"
export * from "./ContributionDialog.vue?vue&type=script&lang=js"

import "./ContributionDialog.vue?vue&type=style&index=0&id=412a360b&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__